var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgConfetti = function SvgConfetti(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 133,
    height: 124,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#confetti_svg__a)",
    strokeMiterlimit: 10,
    strokeWidth: 1.742,
    d: "M100.968 1.164c-2.108-.649-4.439 1.135-4.844 3.303s.75 4.398 2.452 5.807c.73.608 1.632 1.114 2.574 1.064.953-.051 1.905-.831 1.845-1.784-.071-1.054-1.206-1.672-2.199-2.026-1.328-.477-2.736-.852-4.145-.72s-2.827.841-3.486 2.088c-.365.689-.476 1.49-.517 2.27-.06 1.297.082 2.614.598 3.8.517 1.185 1.44 2.229 2.645 2.705.679.274 1.55.324 2.088-.172.304-.284.456-.71.486-1.125.111-1.287-.74-2.503-1.834-3.182s-2.412-.892-3.699-1.013c-.8-.081-1.662-.122-2.371.243-.628.324-1.074.922-1.409 1.55-1.033 1.926-1.195 4.378-.141 6.293 1.064 1.915 3.455 3.08 5.553 2.452"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#confetti_svg__b)",
    strokeMiterlimit: 10,
    strokeWidth: 1.742,
    d: "M39.348 39.417a9.7 9.7 0 0 1 5.259-1.936c.446-.03.912-.02 1.297.193.841.446.993 1.57 1.044 2.523.05.993.07 2.088-.547 2.868-.558.7-1.51.963-2.412.963-.335 0-.71-.061-.892-.335-.111-.162-.122-.375-.132-.567-.03-.74-.04-1.49.223-2.179.568-1.48 2.25-2.21 3.81-2.493.882-.152 1.865-.192 2.615.294s1.114 1.409 1.256 2.29c.325 2.057-.354 4.236-1.773 5.756s-3.567 2.32-5.634 2.118"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#confetti_svg__c)",
    strokeMiterlimit: 10,
    strokeWidth: 1.742,
    d: "M70.466 85.159c.223-1.014 1.044-1.814 1.986-2.27.943-.456 1.987-.608 3.01-.74 1.267-.162 2.625-.294 3.78.264 2.047.983 2.574 3.911 1.49 5.907-1.085 1.997-3.304 3.142-5.533 3.608-.385.08-.852.121-1.125-.152-.172-.172-.223-.426-.274-.669-.162-.83-.304-1.763.193-2.452.476-.659 1.358-.851 2.158-.983 2.138-.365 4.459-.7 6.384.304 2.392 1.256 3.364 4.64 1.986 6.972"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#confetti_svg__d)",
    strokeMiterlimit: 10,
    strokeWidth: 1.742,
    d: "M8.36 56.44c1.47.173 2.959.589 4.064 1.572 1.043.922 1.63 2.25 2.38 3.425s1.845 2.31 3.233 2.422c2.26.182 4.125-2.351 6.374-2.037 1.105.162 2.057 1.094 2.24 2.199"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#confetti_svg__e)",
    strokeMiterlimit: 10,
    strokeWidth: 1.742,
    d: "M49.764 97.44c.943-.557 1.895-1.145 2.615-1.975.709-.832 1.155-1.977.901-3.04-.141-.598-.496-1.125-.77-1.693a6.4 6.4 0 0 1-.233-4.914 6.4 6.4 0 0 1 3.354-3.598"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#confetti_svg__f)",
    strokeMiterlimit: 10,
    strokeWidth: 1.742,
    d: "M22.415 91.269c-1.044-.882-1.115-2.432-1.104-3.79.01-.953.01-1.905.02-2.858 0-.496.01-1.003.202-1.469.487-1.165 1.946-1.54 3.203-1.58 1.388-.041 2.786.151 4.124.567 1.459.456 3.263 1.104 4.327 0 .496-.507.628-1.247.79-1.936.294-1.236.75-2.482 1.672-3.354s2.402-1.246 3.486-.598"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#confetti_svg__g)",
    strokeMiterlimit: 10,
    strokeWidth: 1.742,
    d: "M96.267 49.459c.76-2.594 3.668-4.337 6.313-3.81 1.763.354 3.212 1.54 4.732 2.503 1.51.962 3.354 1.753 5.067 1.226.638-.203 1.216-.578 1.824-.841 2.715-1.196 6.262-.02 7.721 2.574"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#confetti_svg__h)",
    strokeMiterlimit: 10,
    strokeWidth: 1.742,
    d: "M72.24 26.82c.01-.435.364-.79.75-1.002.385-.213.81-.325 1.175-.578.466-.314.77-.841.83-1.398.052-.497-.08-.983-.141-1.48-.06-.496 0-1.043.355-1.388.334-.334.84-.385 1.287-.547a2.7 2.7 0 0 0 1.631-1.723 2.71 2.71 0 0 0-.405-2.34"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#confetti_svg__i)",
    strokeMiterlimit: 10,
    strokeWidth: 1.742,
    d: "M36.126 69.24c.01-.436.364-.791.75-1.004.385-.213.81-.324 1.175-.578.466-.314.77-.84.831-1.398.05-.496-.081-.983-.142-1.48-.05-.496 0-1.043.355-1.388.334-.334.84-.385 1.287-.547a2.7 2.7 0 0 0 1.631-1.722 2.71 2.71 0 0 0-.405-2.341"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#confetti_svg__j)",
    strokeMiterlimit: 10,
    strokeWidth: 1.742,
    d: "M20.418-5.544c-1.195.425-2.411.871-3.475 1.56s-1.987 1.682-2.351 2.908c-.173.568-.213 1.156-.193 1.743.02.537.091 1.085.274 1.591.567 1.632 2.158 2.777 3.85 3.121 1.693.345 3.476-.03 5.067-.709 1.014-.436 2.098-1.216 2.027-2.31-.04-.649-.517-1.206-1.085-1.51-.577-.294-1.236-.375-1.884-.385-.568-.01-1.166.02-1.672.273-.608.304-1.044.882-1.338 1.49-.415.871-.567 1.844-.648 2.807-.112 1.358-.03 2.797.709 3.932.466.719 1.175 1.256 1.956 1.61 2.553 1.196 5.897.325 7.549-1.955"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#confetti_svg__k)",
    strokeMiterlimit: 10,
    strokeWidth: 1.588,
    d: "M-1.328 83.922c.395 1.095.79 2.19 1.419 3.162.638.973 1.54 1.814 2.645 2.148.517.152 1.054.193 1.59.183.487-.02.984-.081 1.45-.244 1.49-.516 2.533-1.965 2.847-3.516s-.03-3.161-.648-4.61c-.396-.923-1.115-1.916-2.108-1.855-.588.04-1.094.466-1.368.993s-.345 1.125-.355 1.723c-.01.517.02 1.064.254 1.53.273.557.8.953 1.357 1.216.801.375 1.683.517 2.564.588 1.236.101 2.554.03 3.587-.649.649-.425 1.145-1.074 1.47-1.783 1.084-2.33.294-5.37-1.784-6.88"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#confetti_svg__l)",
    strokeMiterlimit: 10,
    strokeWidth: 1.742,
    d: "M-5.148 22.515c3.222.871 6.82 2.016 8.32 5.005.486.973.699 2.068.81 3.152.122 1.236.081 2.574-.588 3.618-.668 1.053-2.158 1.651-3.212.993-1.277-.8-1.094-2.787-.263-4.044 1.631-2.462 5.208-3.384 7.823-2.016 1.56.81 2.705 2.3 3.333 3.942.629 1.641.79 3.435.72 5.188-.04.932-.172 1.935-.78 2.645-.619.71-1.865.922-2.463.203-.182-.223-.284-.517-.354-.801-.548-2.381 1.124-4.905 3.394-5.817s4.915-.435 7.073.7c1.611.85 3.152 2.29 3.202 4.114"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#confetti_svg__m)",
    strokeMiterlimit: 10,
    strokeWidth: 1.538,
    d: "M77.023-11.3c-.547 2.898-1.328 6.13-3.861 7.65-.82.497-1.773.75-2.716.912-1.084.183-2.26.244-3.222-.283-.963-.517-1.591-1.794-1.085-2.767.629-1.175 2.382-1.145 3.537-.496 2.27 1.277 3.314 4.357 2.28 6.749-.618 1.428-1.844 2.523-3.253 3.192-1.398.668-2.969.922-4.52.972-.83.03-1.712-.02-2.38-.516-.67-.497-.933-1.581-.335-2.149.193-.182.436-.283.679-.365 2.057-.638 4.388.67 5.34 2.615.953 1.945.71 4.296-.152 6.272-.648 1.47-1.814 2.919-3.415 3.08"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#confetti_svg__n)",
    strokeMiterlimit: 10,
    strokeWidth: 1.597,
    d: "M89.213 71.671c2.898-.983 6.222-1.925 8.887-.415.871.496 1.59 1.216 2.219 1.986.719.881 1.368 1.915 1.388 3.06.021 1.145-.81 2.361-1.945 2.391-1.378.041-2.25-1.57-2.26-2.948-.01-2.706 2.25-5.23 4.935-5.513 1.601-.172 3.232.375 4.55 1.307 1.317.933 2.351 2.21 3.182 3.588.445.73.851 1.56.749 2.411-.111.852-.952 1.652-1.773 1.399-.253-.081-.476-.243-.679-.436-1.631-1.54-1.631-4.317-.365-6.161s3.517-2.837 5.746-3.06c1.662-.173 3.567.152 4.53 1.51"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#confetti_svg__o)",
    d: "M81.765 51.1a2.777 2.777 0 1 0 0-5.552 2.777 2.777 0 0 0 0 5.553"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#confetti_svg__p)",
    strokeMiterlimit: 10,
    strokeWidth: 1.742,
    d: "M65.643 41.049a2.777 2.777 0 1 0 0-5.553 2.777 2.777 0 0 0 0 5.553Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#confetti_svg__q)",
    d: "M25.82 50.645a2.777 2.777 0 1 0 0-5.553 2.777 2.777 0 0 0 0 5.553"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#confetti_svg__r)",
    d: "M2.219 9.747a2.361 2.361 0 1 0 0-4.723 2.361 2.361 0 0 0 0 4.723"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#confetti_svg__s)",
    d: "M113.888 32.719a3.415 3.415 0 1 0 0-6.83 3.415 3.415 0 0 0 0 6.83"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#confetti_svg__t)",
    d: "M36.125 113.866a3.414 3.414 0 1 0 .001-6.828 3.414 3.414 0 0 0-.001 6.828"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#confetti_svg__u)",
    d: "M99.672 100.855a3.415 3.415 0 1 0 0-6.83 3.415 3.415 0 0 0 0 6.83"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#confetti_svg__v)",
    d: "M66.322 61.6a3.445 3.445 0 1 0 0-6.892 3.445 3.445 0 0 0 0 6.891"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#confetti_svg__w)",
    d: "M47.495 24.48a4.246 4.246 0 1 0 0-8.491 4.246 4.246 0 0 0 0 8.491"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#confetti_svg__x)",
    d: "M50.444 62.653a2.25 2.25 0 1 0 0-4.5 2.25 2.25 0 0 0 0 4.5"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#confetti_svg__y)",
    d: "M107.585 62.48a2.25 2.25 0 1 0 0-4.498 2.25 2.25 0 0 0 0 4.499"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#confetti_svg__z)",
    strokeMiterlimit: 10,
    strokeWidth: 1.742,
    d: "m78.655 66.575-6.06 1.58a.848.848 0 0 0-.385 1.43l4.48 4.478c.466.466 1.266.253 1.428-.385l1.581-6.06a.857.857 0 0 0-1.044-1.043Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#confetti_svg__A)",
    strokeMiterlimit: 10,
    strokeWidth: 1.742,
    d: "m46.066 2.552-6.06 1.58a.848.848 0 0 0-.385 1.43l4.48 4.478c.465.466 1.266.253 1.428-.385l1.581-6.06a.856.856 0 0 0-1.044-1.043Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#confetti_svg__B)",
    d: "m30.339 19.09 1.023 3.151c.142.426.537.71.983.71h3.314c.638 0 .912.82.385 1.195l-2.685 1.946c-.365.263-.517.73-.375 1.155l1.023 3.152c.203.608-.496 1.114-1.023.74l-2.686-1.946a1.03 1.03 0 0 0-1.216 0l-2.685 1.945c-.517.375-1.216-.131-1.023-.74l1.023-3.15a1.02 1.02 0 0 0-.375-1.156l-2.685-1.946c-.517-.375-.254-1.195.385-1.195h3.313c.446 0 .841-.284.983-.71l1.024-3.151c.233-.608 1.094-.608 1.297 0"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#confetti_svg__C)",
    d: "m89.904 29.871 1.6 1.966a.77.77 0 0 0 .892.233l2.361-.912a.509.509 0 0 1 .608.75l-1.378 2.128a.79.79 0 0 0 .05.922l1.602 1.966a.51.51 0 0 1-.527.81l-2.442-.648a.785.785 0 0 0-.862.334l-1.378 2.128c-.263.416-.902.244-.932-.243l-.132-2.533a.79.79 0 0 0-.577-.72l-2.442-.648c-.477-.122-.507-.78-.051-.963l2.361-.912a.81.81 0 0 0 .507-.78l-.132-2.533c-.05-.497.568-.73.871-.345"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#confetti_svg__D)",
    d: "m58.135 70.658 1.155 1.429a.56.56 0 0 0 .648.172l1.713-.658c.334-.132.628.243.436.537l-1.004 1.54a.56.56 0 0 0 .041.669l1.155 1.428c.223.274-.04.68-.375.588l-1.773-.476a.57.57 0 0 0-.628.243l-1.004 1.54c-.192.294-.658.173-.678-.182l-.102-1.834a.56.56 0 0 0-.425-.517l-1.774-.476c-.344-.091-.365-.568-.04-.7l1.712-.658a.57.57 0 0 0 .365-.567l-.101-1.835c.01-.344.456-.516.679-.243"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "confetti_svg__a",
    x1: 87.409,
    x2: 103.876,
    y1: 11.958,
    y2: 11.958,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BF35D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5160"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "confetti_svg__b",
    x1: 38.812,
    x2: 51.828,
    y1: 43.211,
    y2: 43.211,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5DC6F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#367BF2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "confetti_svg__c",
    x1: 69.607,
    x2: 86.041,
    y1: 88.255,
    y2: 88.255,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BF35D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5160"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "confetti_svg__d",
    x1: 8.257,
    x2: 27.521,
    y1: 60.154,
    y2: 60.154,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BF35D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5160"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "confetti_svg__e",
    x1: 49.309,
    x2: 55.985,
    y1: 89.81,
    y2: 89.81,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1BBE6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#05BBDD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "confetti_svg__f",
    x1: 20.426,
    x2: 39.579,
    y1: 83.489,
    y2: 83.489,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5DC6F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#367BF2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "confetti_svg__g",
    x1: 95.415,
    x2: 122.685,
    y1: 48.101,
    y2: 48.101,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1BBE6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#05BBDD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "confetti_svg__h",
    x1: 71.359,
    x2: 79.125,
    y1: 21.343,
    y2: 21.343,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1BBE6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#05BBDD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "confetti_svg__i",
    x1: 35.241,
    x2: 43.007,
    y1: 63.765,
    y2: 63.765,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BF35D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5160"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "confetti_svg__j",
    x1: 13.508,
    x2: 29.911,
    y1: 2.82,
    y2: 2.82,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BF35D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5160"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "confetti_svg__k",
    x1: 6.284,
    x2: 6.284,
    y1: 90.215,
    y2: 75.271,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BF35D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5160"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "confetti_svg__l",
    x1: -5.374,
    x2: 22.741,
    y1: 32.087,
    y2: 32.087,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7C48E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A267FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "confetti_svg__m",
    x1: 68.659,
    x2: 70.495,
    y1: -10.856,
    y2: 13.886,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8A57F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEE2C5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "confetti_svg__n",
    x1: 93.881,
    x2: 115.311,
    y1: 79.094,
    y2: 64.793,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5DC6F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#367BF2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "confetti_svg__o",
    x1: 78.998,
    x2: 84.543,
    y1: 48.326,
    y2: 48.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#367BF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5DC6F3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "confetti_svg__p",
    x1: 61.986,
    x2: 69.296,
    y1: 38.269,
    y2: 38.269,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FB8797"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBD44D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "confetti_svg__q",
    x1: 23.049,
    x2: 28.595,
    y1: 47.865,
    y2: 47.865,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FB8797"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBD44D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "confetti_svg__r",
    x1: -0.138,
    x2: 4.575,
    y1: 7.383,
    y2: 7.383,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FB8797"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBD44D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "confetti_svg__s",
    x1: 110.475,
    x2: 117.302,
    y1: 29.299,
    y2: 29.299,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#367BF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5DC6F3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "confetti_svg__t",
    x1: 32.709,
    x2: 39.536,
    y1: 110.453,
    y2: 110.453,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#367BF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5DC6F3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "confetti_svg__u",
    x1: 96.263,
    x2: 103.091,
    y1: 97.439,
    y2: 97.439,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7C48E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A267FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "confetti_svg__v",
    x1: 62.868,
    x2: 69.765,
    y1: 58.157,
    y2: 58.157,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1BBE6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#05BBDD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "confetti_svg__w",
    x1: 43.252,
    x2: 51.742,
    y1: 20.231,
    y2: 20.231,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BF35D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5160"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "confetti_svg__x",
    x1: 48.196,
    x2: 52.694,
    y1: 60.405,
    y2: 60.405,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#367BF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5DC6F3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "confetti_svg__y",
    x1: 105.338,
    x2: 109.835,
    y1: 60.228,
    y2: 60.228,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BF35D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5160"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "confetti_svg__z",
    x1: 71.069,
    x2: 80.611,
    y1: 70.435,
    y2: 70.435,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FB8797"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBD44D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "confetti_svg__A",
    x1: 38.48,
    x2: 48.023,
    y1: 6.412,
    y2: 6.412,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1BBE6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#05BBDD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "confetti_svg__B",
    x1: 23.087,
    x2: 36.323,
    y1: 24.962,
    y2: 24.962,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FB8797"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBD44D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "confetti_svg__C",
    x1: 86.382,
    x2: 95.804,
    y1: 36.029,
    y2: 32.395,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FB8797"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBD44D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "confetti_svg__D",
    x1: 55.584,
    x2: 62.422,
    y1: 75.134,
    y2: 72.497,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FB8797"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBD44D"
  })))));
};
export default SvgConfetti;